import { Injectable, inject } from '@angular/core';
import {LorenNotification} from './interfaces/loren-notification.interface';
import {GenericItems} from '../../interfaces/generic-items.interface';
import {LorenNotificationStatus} from './interfaces/loren-notification-status.interface';
import {BehaviorSubject} from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class LorenNotificationService {
    private http = inject(HttpClient);

    private readonly baseUrl = `${environment.apiServerUrl}/notifications`;

    private notificationStatusUpdate = new BehaviorSubject<number>(null);
    private reloadNotifications = new BehaviorSubject<boolean>(false);

    getUserNotifications() {
        return this.http.get<GenericItems<LorenNotification>>(this.baseUrl, {});
    }

    getUserNotification(notificationId: number) {
        return this.http.get<LorenNotification>(`${this.baseUrl}/${notificationId}`, {});
    }

    updateNotificationStatus(notificationId) {
        const data: LorenNotificationStatus = {
            seen: true
        };

        return this.http.patch<LorenNotificationStatus>(`${this.baseUrl}/${notificationId}`, data);
    }

    notificationStatusUpdateEvent() {
        return this.notificationStatusUpdate.asObservable();
    }

    reloadNotifications$() {
        return this.reloadNotifications.asObservable();
    }

    publishNotificationStatusUpdateEvent(notificationId: number) {
        this.notificationStatusUpdate.next(notificationId);
    }

    reloadNotificationsEvent(state: boolean) {
        this.reloadNotifications.next(state);
    }

    markAllNotificationsAsRead() {
        return this.http.post(`${this.baseUrl}/mark-all-seen`, {});
    }
}
